import { render, staticRenderFns } from "./News-swiper.vue?vue&type=template&id=a77a4618&scoped=true&"
import script from "./News-swiper.vue?vue&type=script&lang=js&"
export * from "./News-swiper.vue?vue&type=script&lang=js&"
import style0 from "./News-swiper.vue?vue&type=style&index=0&id=a77a4618&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77a4618",
  null
  
)

export default component.exports